import { useMemo } from "react";

import { useAvailableFilters } from "../queries/use-available-filters";

export const useRequiredDatesCount = (length: number) => {
  const { availableFilters, loading } = useAvailableFilters();
  const sufficientDates = useMemo(() => {
    if (typeof availableFilters.dates === "undefined") {
      return;
    }

    return availableFilters.dates.length >= length;
  }, [availableFilters.dates]);

  return { sufficientDates, loading };
};
